import axios from 'axios';

export const subscribe = data => {
  const res = axios({
    url: `${process.env.APP_MINFIN_API_DOMAIN}/modules/connector/connector.php`,
    method: 'POST',
    data,
    headers: { 'Content-Type': 'multipart/form-data' },
  });

  return res;
};
